<template>
  <div class="home">
    <div class="header-box">
      <div class="logos">
        <img alt="Feegow logo" src="../assets/logo-feegow.svg" />
        <span>+</span>
        <img alt="Vue logo" src="../assets/logo-vue.png" />
      </div>
      <HelloWorld msg="Feegow Vue.js Development Environment" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HelloWorld from "@/components/HelloWorld.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    HelloWorld,
  },
});
</script>

<style scoped lang="scss">
.home {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  padding: 60px 20px;
  display: flex;
  justify-content: center;
}

.header-box {
  text-align: center;
  background-color: #fff;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);
  max-width: 720px;
  width: 100%;
}

.logos {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  span {
    font-size: 2rem;
    margin: 0 1rem;
  }
  img {
    max-height: 50px;
    width: auto;
  }
}
</style>
